import { TextInput as RaTextInput } from "react-admin";

export const TextInput = (props) => (
  <RaTextInput helperText={false} {...props} />
);
